import { onUnmounted } from 'vue';

/**
 * @description 长按事件hook
 * @author Ben
 * @date 2021-03-26
 */

 interface IConfig {
  element:HTMLElement; // 绑定事件的元素
  func:Function; // 长按回调事件
  timeOut?:number; // 长按延时时间
}

type timeOutEventType = NodeJS.Timeout

// 清除定时器
const clearTimeOutFn = (timeOutEvent:timeOutEventType) => clearTimeout(timeOutEvent);

export const useLongPres = ({ element, func, timeOut = 500 }:IConfig) => {
  let timeOutEvent:timeOutEventType;
  if(!element) {
    throw new Error('未找到对应element');
  };
  element.addEventListener('touchstart', function() {
    // 开启定时器前先清除定时器，防止重复触发
    clearTimeout(timeOutEvent);
    // 开启延时定时器
    timeOutEvent = setTimeout(function() {
      // 调用长按之后的逻辑函数func
      func();
    }, timeOut);
  });

  // 长按过程中，手指是不能移动的，若移动则清除定时器，中断长按逻辑
  element.addEventListener('touchmove', () => clearTimeOutFn(timeOutEvent));

  // 若手指离开屏幕，时间小于我们设置的长按时间，则为点击事件，清除定时器，结束长按逻辑
  element.addEventListener('touchend', () => clearTimeOutFn(timeOutEvent));

  // 解绑事件监听
  onUnmounted(() => {
    element.removeEventListener('touchstart', () => clearTimeOutFn(timeOutEvent));
    element.removeEventListener('touchmove', () => clearTimeOutFn(timeOutEvent));
    element.removeEventListener('touchend', () => clearTimeOutFn(timeOutEvent));
  });
};


